export default __webpack_public_path__ + "static/media/BecaMilano_Curso01_Banner_Historia_Full.af571192.jpg";